import { render, staticRenderFns } from "./BoxRemovalCard.vue?vue&type=template&id=5f88fc63&"
import script from "./BoxRemovalCard.vue?vue&type=script&lang=js&"
export * from "./BoxRemovalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports